// extracted by mini-css-extract-plugin
export default {"container":"info-block_container__-XXXy","label":"info-block_label__gJU5V","text":"info-block_text__n7bes"};